import { formatDisplayNameByLocationLevel } from 'src/helpers/listings/search'

export const selectSavedSearchesLoading = state => state.savedSearches.loading
export const selectSavedSearches = state =>
  state.savedSearches.data?.map(savedSearch => {
    const level = savedSearch?.location?.level
    const name = savedSearch?.location?.name

    return {
      ...savedSearch,
      displayName: formatDisplayNameByLocationLevel(level, name),
    }
  })
